/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerById200ResponseAddressesInner
 */
export interface GetCustomerById200ResponseAddressesInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    details?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    postalCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerById200ResponseAddressesInner
     */
    longitude?: string;
}

/**
 * Check if a given object implements the GetCustomerById200ResponseAddressesInner interface.
 */
export function instanceOfGetCustomerById200ResponseAddressesInner(value: object): value is GetCustomerById200ResponseAddressesInner {
    return true;
}

export function GetCustomerById200ResponseAddressesInnerFromJSON(json: any): GetCustomerById200ResponseAddressesInner {
    return GetCustomerById200ResponseAddressesInnerFromJSONTyped(json, false);
}

export function GetCustomerById200ResponseAddressesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerById200ResponseAddressesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'address': json['address'] == null ? undefined : json['address'],
        'details': json['details'] == null ? undefined : json['details'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'selected': json['selected'] == null ? undefined : json['selected'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function GetCustomerById200ResponseAddressesInnerToJSON(json: any): GetCustomerById200ResponseAddressesInner {
    return GetCustomerById200ResponseAddressesInnerToJSONTyped(json, false);
}

export function GetCustomerById200ResponseAddressesInnerToJSONTyped(value?: GetCustomerById200ResponseAddressesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'address': value['address'],
        'details': value['details'],
        'postalCode': value['postalCode'],
        'selected': value['selected'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

